var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-6 md:px-12"
  }, [_c('create-new-folder', {
    attrs: {
      "data-to-show": _vm.isCreateFolderPopupDisplayed,
      "errors": _vm.errorsCreateNewFolder,
      "parent-folder": _vm.parentFolder
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupAddNewFolder(val);
      },
      "createNewFolder": function (folder) {
        _vm.createFolder(folder);
      }
    }
  }), _vm._v(" "), _c('edit-folder', {
    attrs: {
      "data-to-show": _vm.isEditFolderPopupDisplayed,
      "errors": _vm.errorsEditFolder,
      "folder": _vm.folderToEdit
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupEditFolder(val);
      },
      "editFolder": function (folderEdited) {
        _vm.editFolder(folderEdited);
      }
    }
  }), _vm._v(" "), _c('delete-folder', {
    attrs: {
      "data-to-show": _vm.isDeleteFolderPopupDisplayed,
      "errors": _vm.errorsDeleteFolder,
      "folder": _vm.folderToDelete
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupDeleteFolder(false);
      },
      "deleteFolder": function ($event) {
        return _vm.deleteFolder();
      }
    }
  }), _vm._v(" "), _c('move-folder', {
    attrs: {
      "data-to-show": _vm.isMoveFilePopupDisplayed,
      "file-to-move": _vm.fileToMove,
      "errors": _vm.errorsMoveFile
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupMoveFile(val);
      },
      "moveFile": function (file) {
        _vm.moveFile(file);
      }
    }
  }), _vm._v(" "), _c('add-member', {
    attrs: {
      "data-to-show": _vm.isAddMemberPopupDisplayed,
      "folder": _vm.folderToShare,
      "errors": _vm.errorsAddMemberFolder
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupAddMember(val);
      },
      "addMembers": function (members) {
        _vm.addMembers(members);
      },
      "editUserRights": function (user, newRights) {
        _vm.editUserRights(user, newRights);
      },
      "editRoleRights": function (role, newRights) {
        _vm.editRoleRights(role, newRights);
      },
      "revokeUserRights": function (user) {
        _vm.revokeUserRights(user);
      },
      "revokeRoleRights": function (role) {
        _vm.revokeRoleRights(role);
      }
    }
  }), _vm._v(" "), _c('add-new-file', {
    attrs: {
      "data-to-show": _vm.stateAddFilePopup,
      "loading": _vm.addNewFileLoading,
      "file-temp": _vm.fileTemp,
      "errors": _vm.errorsAddNewFile,
      "current-folder": _vm.path.length > 0 ? _vm.path[_vm.path.length - 1].id : null
    },
    on: {
      "showChange": function (val) {
        _vm.changeStatePopupAddNewFile(val);
      },
      "addTempFile": function (data) {
        _vm.addTempFile(data);
      },
      "addFile": function (infos) {
        _vm.addFile(infos);
      }
    }
  }), _vm._v(" "), _c('edit-file', {
    attrs: {
      "data-to-show": _vm.isEditFilePopupDisplayed,
      "errors": _vm.errorsEditFile,
      "file": _vm.fileToEdit
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupEditFile(val);
      },
      "editFile": function (fileEdited) {
        _vm.editFile(fileEdited);
      }
    }
  }), _vm._v(" "), _c('preview-file', {
    attrs: {
      "data-to-show": _vm.isPreviewPopupDisplayed,
      "file": _vm.fileToDisplay
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupPreview(false);
      }
    }
  }), _vm._v(" "), _c('div', [_vm.isRootPage ? _c('div', {
    staticClass: "flex"
  }, [_c('h4', {
    staticClass: "text-indigo-600 text-left"
  }, [_vm._v("Dossiers récents")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _vm.folders.length > 0 ? _c('div', [_c('h5', {
    staticClass: "text-gray-900 text-right cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.openFolder();
      }
    }
  }, [_vm._v("\n          Voir tout\n        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.isCurrentFolderPage || _vm.isRecentFilesPage ? _c('div', {
    staticClass: "flex"
  }, [_c('h4', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-indigo-600 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.goToPath();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isCurrentFolderPage && _vm.path.length == 1 && Object.keys(_vm.path[0]).length == 0 ? 'Tous les dossiers' : _vm.isCurrentFolderPage ? 'Dossiers' : _vm.isRecentFilesPage && _vm.files.length > 0 ? 'Tous les fichiers' : '') + "\n        ")]), _vm._v(" "), _vm._l(_vm.path.filter(function (p) {
    return Object.keys(p).length > 0 && !_vm.isRecentFilesPage;
  }), function (p, i) {
    return _c('span', {
      key: i,
      staticClass: "text-gray-600 cursor-pointer",
      on: {
        "click": function ($event) {
          return _vm.goToPath(i);
        }
      }
    }, [_vm._v("\n          > " + _vm._s(p.name))]);
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative w-max"
  }, [_c('div', {
    staticClass: "my-10"
  }, [_vm.isRootPage && _vm.canEdit && _vm.$can('documents_create') || _vm.isCurrentFolderPage && Object.keys(_vm.path[_vm.path.length - 1]).length == 0 || _vm.$editFile(_vm.path[_vm.path.length - 1], _vm.currentPage) ? _c('add-button', {
    attrs: {
      "libelle": 'Ajouter un nouveau ' + (_vm.isRootPage ? 'dossier' : _vm.isCurrentFolderPage ? 'dossier ou fichier' : _vm.isRecentFilesPage ? 'fichier' : ''),
      "with-dropdown": _vm.isCurrentFolderPage
    },
    on: {
      "add": _vm.addButtonDisplaySomething
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.isDropdownCreateFolderOrFileDisplay ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayDropdownAddNewFolderOrFile,
      expression: "displayDropdownAddNewFolderOrFile"
    }],
    staticClass: "absolute z-10 right-0 top-8 px-5 py-3 bg-white shadow rounded-xl text-sm"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5 text-gray-600"
  }, [_c('p', {
    staticClass: "hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.displayPopupAddNewFolder(true);
      }
    }
  }, [_vm._v("\n            Nouveau dossier\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.changeStatePopupAddNewFile(1);
      }
    }
  }, [_vm._v("\n            Nouveau fichier\n          ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-12 mb-12"
  }, _vm._l(_vm.listFolders.filter(function (f, i) {
    return (i < 3 || _vm.isCurrentFolderPage) && !_vm.isRecentFilesPage;
  }), function (folder, numFolder) {
    return _c('div', {
      key: numFolder,
      staticClass: "col-span-full md:col-span-1"
    }, [_c('folder-card', {
      attrs: {
        "editable": _vm.$editFile(folder, _vm.currentPage) && _vm.canEdit,
        "is-admin": _vm.$adminFile(folder, _vm.currentPage),
        "is-owner": _vm.$ownerFile(folder, _vm.currentPage),
        "folder": folder,
        "folders": _vm.folders,
        "files": _vm.files,
        "in-neopass-form": _vm.currentPage.includes('/form/neopass/'),
        "smaller": _vm.currentPage.includes('/form/neopass/')
      },
      on: {
        "openFolder": function ($event) {
          return _vm.openFolder(folder);
        },
        "editFolder": function ($event) {
          return _vm.displayPopupEditFolder(true, folder);
        },
        "downloadFolder": function ($event) {
          return _vm.downloadAFolder(folder);
        },
        "deleteFolder": function ($event) {
          return _vm.displayPopupDeleteFolder(true, folder);
        },
        "moveFolder": function ($event) {
          return _vm.displayPopupMoveFile(true, folder);
        },
        "addMember": function ($event) {
          return _vm.displayPopupAddMember(true, folder);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _vm.isRootPage ? _c('div', [_vm.files.length > 0 ? _c('div', {
    staticClass: "flex my-10"
  }, [_c('h4', {
    staticClass: "text-indigo-600 text-left"
  }, [_vm._v("Fichiers récents")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-gray-900 text-right cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.displayAllFiles();
      }
    }
  }, [_vm._v("\n          Voir tout\n        ")])]) : _vm._e(), _vm._v(" "), _vm.canEdit && _vm.$can('documents_create') ? _c('add-button', {
    attrs: {
      "libelle": "Ajouter un nouveau fichier"
    },
    on: {
      "add": function ($event) {
        return _vm.changeStatePopupAddNewFile(1);
      }
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _vm.files.length > 0 && (_vm.isRootPage || _vm.isRecentFilesPage) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._l(_vm.files.filter(function (f, i) {
    return i < 5 || _vm.isRecentFilesPage;
  }), function (file, numFile) {
    return _c('div', {
      key: numFile,
      staticClass: "grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-base items-center odd:bg-gray-300 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "col-span-2 justify-self-center"
    }, [_c('tag', {
      attrs: {
        "responsive": "",
        "libelle": file.type.toUpperCase(),
        "theme-color": _vm.colorByType[file.type.toLowerCase()] ? _vm.colorByType[file.type.toLowerCase()] : 'default'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-8 md:col-span-2"
    }, [_c('info-bulle-hover', {
      attrs: {
        "name": 'filename' + file.id,
        "libelle": file.name.substring(0, file.name.lastIndexOf('.')),
        "is-display-tooltip": _vm.isFilenameTooltipDisplay == file.id,
        "position": "bottom-3 left-0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      on: {
        "mouseover": function ($event) {
          _vm.isFilenameTooltipDisplay = file.id;
        },
        "mouseleave": function ($event) {
          _vm.isFilenameTooltipDisplay = -1;
        }
      }
    }, [_vm._v("\n          " + _vm._s(file.name.substring(0, file.name.lastIndexOf('.'))) + "\n        ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 md:block hidden"
    }, [_c('info-bulle-hover', {
      attrs: {
        "name": 'parent' + file.id,
        "libelle": file.folder_id == null ? 'Mon dépôt de documents' : _vm.folders.filter(function (f) {
          return f.id == file.folder_id;
        }).length > 0 ? _vm.folders.filter(function (f) {
          return f.id == file.folder_id;
        })[0].name : 'Mon dépôt de documents',
        "is-display-tooltip": _vm.isParentFolderNameTooltipDisplay == file.id,
        "position": "bottom-3 left-0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      on: {
        "mouseover": function ($event) {
          _vm.isParentFolderNameTooltipDisplay = file.id;
        },
        "mouseleave": function ($event) {
          _vm.isParentFolderNameTooltipDisplay = -1;
        }
      }
    }, [_vm._v("\n          " + _vm._s(file.folder_id == null ? 'Mon dépôt de documents' : _vm.folders.filter(function (f) {
      return f.id == file.folder_id;
    }).length > 0 ? _vm.folders.filter(function (f) {
      return f.id == file.folder_id;
    })[0].name : 'Mon dépôt de documents') + "\n        ")])], 1), _vm._v(" "), _c('list-avatars', {
      staticClass: "col-span-2 md:block hidden justify-self-center bottom-1/6",
      attrs: {
        "list-items": file.users,
        "libelle-firstname": "firstname",
        "libelle-lastname": "lastname"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 md:block hidden"
    }, [_vm._v("\n        " + _vm._s(new Date(file.created_at).toLocaleDateString()) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 justify-self-center"
    }, [_c('div', {
      staticClass: "cursor-pointer p-5 relative",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displaySubMenuFile(file.id);
        }
      }
    }, [_c('icon', {
      staticClass: "text-pink-600",
      attrs: {
        "name": "more-vertical"
      }
    }), _vm._v(" "), _vm.subMenuFileNumber == file.id ? _c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.hideSubMenuFile,
        expression: "hideSubMenuFile"
      }],
      staticClass: "absolute rounded-md bg-white shadow-lg shadow-gray-600 p-5 right-0 z-30"
    }, [_c('div', {
      staticClass: "flex flex-col space-y-2"
    }, [_vm.constants.FILE_TYPES.img.includes(file.type.toLowerCase()) || _vm.constants.FILE_TYPES.pdf.includes(file.type.toLowerCase()) ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupPreview(true, file);
        }
      }
    }, [_vm._v("\n                Visualiser\n              ")]) : _vm._e(), _vm._v(" "), _vm.canEdit && _vm.$can('documents_move') ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupMoveFile(true, file);
        }
      }
    }, [_vm._v("\n                Déplacer\n              ")]) : _vm._e(), _vm._v(" "), _vm.$adminFile(file, _vm.currentPage) && _vm.$can('documents_share') && !_vm.$freeParticulier() ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupAddMember(true, file);
        }
      }
    }, [_vm._v("\n                Partager\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.downloadAFile(file);
        }
      }
    }, [_vm._v("\n                Télécharger\n              ")]), _vm._v(" "), _vm.$editFile(file, _vm.currentPage) && _vm.$can('documents_edit_folder') ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupEditFile(true, file);
        }
      }
    }, [_vm._v("\n                Éditer\n              ")]) : _vm._e(), _vm._v(" "), _vm.$editFile(file, _vm.currentPage) && _vm.$can('documents_delete') ? _c('div', {
      staticClass: "cursor-pointer text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.displayPopupDeleteFolder(true, file);
        }
      }
    }, [_vm._v("\n                Supprimer\n              ")]) : _vm._e()])]) : _vm._e()], 1)])], 1);
  })], 2) : _vm._e(), _vm._v(" "), _vm.isCurrentFolderPage ? _c('div', {
    staticClass: "grid grid-cols-3 gap-12"
  }, _vm._l(_vm.currentFiles, function (file, numFile) {
    return _c('div', {
      key: numFile,
      staticClass: "col-span-full md:col-span-1"
    }, [_c('file-card', {
      attrs: {
        "file": file,
        "editable": _vm.$editFile(file, _vm.currentPage) && _vm.canEdit,
        "is-admin": _vm.$adminFile(file, _vm.currentPage),
        "is-owner": _vm.$ownerFile(file, _vm.currentPage),
        "in-neopass-form": _vm.currentPage.includes('/form/neopass/')
      },
      on: {
        "openFile": function ($event) {
          return _vm.displayPopupPreview(true, file);
        },
        "downloadFile": function ($event) {
          return _vm.downloadAFile(file);
        },
        "moveFile": function ($event) {
          return _vm.displayPopupMoveFile(true, file);
        },
        "addMember": function ($event) {
          return _vm.displayPopupAddMember(true, file);
        },
        "editFile": function ($event) {
          return _vm.displayPopupEditFile(true, file);
        },
        "deleteFile": function ($event) {
          return _vm.displayPopupDeleteFolder(true, file);
        }
      }
    })], 1);
  }), 0) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-gray-600 text-lg items-center"
  }, [_c('div', {
    staticClass: "col-span-2 justify-self-center"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-10 md:col-span-2"
  }, [_vm._v("Nom du fichier")]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2 md:block hidden"
  }, [_vm._v("Dossier parent")]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2 md:block hidden justify-self-center"
  }, [_vm._v("\n        Membres\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2 md:block hidden"
  }, [_vm._v("Date création")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 md:block hidden justify-self-center"
  }, [_vm._v("Plus")])]);

}]

export { render, staticRenderFns }